export const policyInfoPageNumber = 1
export const benefitGroupPageNumber = 2
export const benefitPageNumber = 3
export const benefitRequiredDocumentPageNumber = 4
export const benefitFormPageNumber = 5
export const reviewPageNumber = 6
export const submittedClaimPageNumber = 7

export const passedAwayCoverageHeaderId = 76
export const insuredDisabledCoverageHeaderId = 77
export const requiredMedicalAttentionCoverageHeaderId = 78
export const childCoverageHeaderId = 79
export const lossAndDamageOfBicycleCoverageHeaderId = 80
export const optionalCoverageHeaderId = 81
export const otherCoverageHeaderId = 82

export const basicCoverageDetailName = null

export const sep = "/"

export const deathFormName = "DeathForm"
export const disablementFormName = "DisablementForm"
export const medicalExpensesFormName = "MedicalExpensesForm"
export const hospitalAllowanceFormName = "HospitalAllowanceForm"
export const bicycleClaimsFormName = "BicycleClaimsForm"
export const otherBenefitsFormName = "OtherBenefitsForm"
export const reviewFormName = "ReviewForm"

export const birthCertificateDocumentId = 340
